import actionTypes from '../actionTypes';

export function requestRaces() {
  return {
    type: actionTypes.RACES_REQUEST,
  };
}

export function successRaces(payload: any) {
  return {
    type: actionTypes.RACES_SUCCESS,
    payload,
  };
}

export function failRaces(e: any) {
  return {
    type: actionTypes.RACES_FAILURE,
    exception: e,
  };
}
